const cleanDataTypes = ["address", "name", "company", "date", "email", "phone", "currency", "notes"]

export default cleanDataTypes